// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module__chatContainer--sH2Ee{position:fixed;right:20px;bottom:20px;z-index:1500}.style-module__chatContainer__wrap--HJOFQ{position:relative}`, "",{"version":3,"sources":["webpack://./src/components/Layout/ChatContainer/style.module.scss"],"names":[],"mappings":"AAAA,oCACE,cAAA,CACA,UAAA,CACA,WAAA,CACA,YAAA,CAEA,0CACE,iBAAA","sourcesContent":[".chatContainer {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 1500;\n\n  &__wrap {\n    position: relative;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatContainer": `style-module__chatContainer--sH2Ee`,
	"chatContainer__wrap": `style-module__chatContainer__wrap--HJOFQ`
};
export default ___CSS_LOADER_EXPORT___;
